import { render, staticRenderFns } from "./otherrule.vue?vue&type=template&id=771b58ab"
import script from "./otherrule.vue?vue&type=script&lang=js"
export * from "./otherrule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports